// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__27iSy","content":"styles_content__eNVl-","selectAll":"styles_selectAll__3TV3F"};